<template>
  <div class="serviceDetail">
    <div class="header">
      <div class="headerBox">
        <div class="header-left">
          <div class="Img">
            <img :src="serviceInfo.icon" alt="">
          </div>
          <div class="Text">
            <span>{{serviceInfo.name}}</span>
            <div class="rating">
              <rating :score="serviceInfo.score"></rating>
            </div>
          </div>
        </div>
        <div v-if="serviceInfo.inPower" class="header-right">
          <div class="btn" v-if="detailStatus && (getHandleType  === 1 || getHandleType === 2 || getHandleType === 3 )"
               @click="handleServiceAction">
            <span>{{getHandleBtnText}}</span>
          </div>
          <div class="biao" v-if="!detailStatus">
            <div>进行中({{serviceInfo.runingNum}})</div>
            <div>已完成({{serviceInfo.finishNum}})</div>
            <div>我发起的({{serviceInfo.myApplyNum}})</div>
          </div>
        </div>
      </div>
      <div class="close" @click="close">
        <i class="iconfont icon-bohui2"></i>
      </div>
    </div>
    <div class="container" v-if="detailStatus">
      <div class="container-left">
        <div class="title">
          <div class="title-left">
            <span>服务指南</span>
          </div>
          <div class="title-right">
            <div v-if="false" class="qr-container">
              <i class="icon-font bcsxufenxiang"></i>
              <span>分享</span>
              <div class="qrcode">
                <img :src="serviceInfo.plusinfo" alt="qr"/>
              </div>
            </div>
            <collect :collection="serviceInfo.collection" @bindCollect="toggleCollectStatus"></collect>
            <!--              <div>-->
            <!--                <i class="icon-font bcsxufujian"></i>-->
            <!--                <span>附件下载</span>-->
            <!--              </div>-->
          </div>
        </div>
        <div class="guide">
          <div class="guide-item">
            <h2 class="guide-item-title">注意事项</h2>
            <div v-html="serviceGuide.attention" class="guideContent"></div>
          </div>
          <div class="guide-item">
            <h2 class="guide-item-title">附件下载</h2>
            <div class="guideContent fileList">
              <div @click="openNewTab(item)" v-for="item in serviceGuide.attaList" class="fileContainer">
                {{item.realName}}
              </div>
            </div>
          </div>
          <div class="guide-item">
            <h2 class="guide-item-title">流程图</h2>
            <div class="guideContent imgList">
              <div @click="openNewTab(item)" v-for="item in serviceGuide.imgList" class="imgContainer">
                <img :src="item.storeName"/>
              </div>
            </div>
          </div>
          <div class="guide-item">
            <h2 class="guide-item-title">流程说明</h2>
            <div v-html="serviceGuide.body" class="guideContent"></div>
          </div>
        </div>
      </div>
      <div class="container-right">
        <div class="unit">
          <div class="title">
            <div class="title-left">
              <span>承办单位</span>
            </div>
            <div class="title-right"></div>
          </div>
          <ul>
            <li>
              <p>开放对象：</p>
              <p>{{serviceGuide.open_user}}</p>
            </li>
            <li>
              <p>负责单位：</p>
              <p>{{serviceGuide.guide_resp_dept_name}}</p>
            </li>
            <li>
              <p>联系人：</p>
              <p>{{serviceGuide.link_man}}</p>
            </li>
            <li>
              <p>联系电话：</p>
              <p>{{serviceGuide.link_tel}}</p>
            </li>
            <li>
              <p>办理日期：</p>
              <p>{{serviceGuide.service_day}}</p>
            </li>
            <li>
              <p>办理时间：</p>
              <p>{{serviceGuide.service_time}}</p>
            </li>
            <li>
              <p>办理地点：</p>
              <p>{{serviceGuide.apply_address}} <span v-if="false"
                                                      @click="openMap(serviceGuide.longitude,serviceGuide.latitude,serviceGuide.apply_address)"
                                                      class="tomap"><i class="iconfont icon-ico_site"></i></span></p>
            </li>
          </ul>
        </div>
        <div class="matter" v-if="personageHistoryData.length > 0">
          <div class="title">
            <div class="title-left">
              <span>我的事项</span>
            </div>
            <div class="title-right">
              <!--                <span>详情</span>-->
              <!--                <i class="iconfont icon-youjiantou"></i>-->
            </div>
          </div>
          <!--            <div class="num">-->
          <!--              <span>进行中({{serviceInfo.runingNum}})</span>-->
          <!--              <span>已完成({{serviceInfo.finishNum}})</span>-->
          <!--              <span>我发起的({{serviceInfo.myApplyNum}})</span>-->
          <!--            </div>-->
          <ul>
            <li class="matter-item" v-for="item in personageHistoryData">
              <div class="content">
                <div class="content-left">
                  <span>{{item.title}}</span>
                </div>
                <div class="content-right" :style="item.currentState === 2 ? 'color: #CB4258' : ''">
                  <span>{{item.currentText}}</span>
                </div>
              </div>
              <div class="time">{{item.createTime}}</div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="handle" v-if="!detailStatus">
      <div v-if="getHandleType===1" class="iframeBox">
        <div class="title">
          <div class="title-left">
          </div>
          <div class="title-right">
            <div v-if="false" class="qr-container">
              <i class="icon-font bcsxufenxiang"></i>
              <span>分享</span>
              <div class="qrcode">
                <img :src="serviceInfo.plusinfo" alt="qr"/>
              </div>
            </div>
            <collect :collection="serviceInfo.collection" @bindCollect="toggleCollectStatus"></collect>
            <!--              <div @click="toggleCollectStatus" class="collect" :class="{'on':serviceInfo.collection}">-->
            <!--                <i class="icon-font bcsxushoucang"></i>-->
            <!--                <span>收藏</span>-->
            <!--              </div>-->
            <!--              <div>-->
            <!--                <i class="icon-font bcsxufujian"></i>-->
            <!--                <span>附件下载</span>-->
            <!--              </div>-->
          </div>
        </div>
        <iframe class="iframe" :src="serviceInfo.pc_url" frameborder="0"></iframe>
        <div v-if="false" class="btnBox">
          <div>提交</div>
          <div>流程</div>
          <div>暂存</div>
          <div>重置</div>
        </div>
      </div>
      <div v-if="getHandleType===1" class="processBox">
        <h2>审批流程</h2>
        <div class="process">
          <iframe :src="plan_url" frameborder="0"></iframe>
        </div>
        <!--        <div class="step">-->
        <!--          <div class="con">-->
        <!--            <div class="line"></div>-->
        <!--            <div class="step-item" v-for="(item, index) in 6">-->
        <!--              <span>{{item}}</span>-->
        <!--              <span class="text">-->
        <!--                  分管领导审批-->
        <!--                </span>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </div>-->
      </div>
      <div v-if="getHandleType===2" class="iframeBox">
        <div class="tabs-content orderOnline" ref="orderOnline">

          <div class="orderinfo">
            <img class="avatar" src="../../assets/images/bulb.png" alt=""/>
            <h3>服务预约</h3>
            <p>办理人：{{serviceGuide.link_man}}</p>
            <p>办理地点：{{serviceGuide.apply_address}}</p>

            <ul>
              <li @click="monthOffset(0)">上月</li>
              <li @click="toToday">本月</li>
              <li @click="monthOffset(1)">下月</li>
            </ul>
          </div>

          <div class="desc">
            <p><span class="grey"></span>不可预约</p>
            <p><span class="blue"></span>可预约</p>
            <p><span class="yellow"></span>预约过半</p>
            <p><span class="red"></span>预约已满</p>
            <p><span class="green"><i class="iconfont icon-yuyue"></i></span>已经预约(再次点击可取消预约)</p>

            <p>上午：08：30-11：30</p>
            <p>下午：14：30-17：00</p>
            <p>晚上：</p>
            <p>办理电话： 3985081</p>
            <p>服务说明：</p>
            <p>正常工作日均可办理，建议使用网上办理</p>
          </div>
          <div class="orderCalendar">
            <order-calendar @borderDateOffset="borderDateOffset" @orderAction="orderAction"
                            @calendarChange="calendarChange" @mouseenter="mouseenter"
                            @mousemove="mousemove" @mouseleave="mouseleave" ref="orderCalendar"></order-calendar>
          </div>
          <div v-if="currentOrderHanleData" class="orderActionContainer">
            <order-action @orderFinish="orderFinish" @close="closeOrderAction"
                          :handleData="currentOrderHanleData"></order-action>
          </div>

          <div :style="floatBoxStyle" class="floatBox">
            <h4>{{floatBoxPayload.time}}</h4>
            <div>
              <p>状态：{{floatBoxPayload.status}}</p>
              <p>可预约人数：{{floatBoxPayload.freeCount}}</p>
              <p>已预约人数：{{floatBoxPayload.holdCount}}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="evaluateBox">
        <h2>服务评价
          <el-rate :colors="['#006ec7','#006ec7','#006ec7','#006ec7','#006ec7']" v-model="ratingValue"></el-rate>
        </h2>
        <div class="btnBox">
          <div @click="ratingSubmit" class="btn">
            提交评论
          </div>
        </div>
      </div>
      <div class="evaluateList" v-if="ratingTotalCount > 0">
        <div class="number">{{ratingTotalCount}}条评论</div>
        <div class="list" v-for="item in  ratingList">
          <div class="list-user">
            <div class="Img">
              <img :src="item.photo" alt="">
            </div>
            <span class="name">{{item.username}}</span>
            <span class="time">{{item.time}}</span>
          </div>
          <div class="list-con">
            {{item.content}}
          </div>
        </div>
        <div class="more" @click="onMore" v-if="ratingTotalCount > ratingList.length">
          <p>查看更多</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import orderCalendar from "components/order/orderCalendar"
  import serviceRating from "components/service/serviceRating"
  import rating from "components/globalComp/rating"
  import ratingSet from "components/globalComp/ratingSet"
  import stateBall from "components/service/stateBall"
  import orderAction from 'components/order/orderAction'
  import collect from 'components/service/collect'
  //通信总线
  import Bus from 'common/js/bus.js'
  //地图
  import bdMap from "components/service/bdMapModal"
  //axios
  import axios from 'axios'
  import apiConfig from 'common/js/api_config'
  //vuex
  import {mapState, mapGetters, mapMutations} from 'vuex'
  import store from 'store/index'
  import serviceTodo from 'components/service/serviceTodo'

  export default {
    name: "serviceDetail",
    data() {
      return {
        detailStatus: true,
        plan_url: '',
        //服务ID
        serviceId: null,
        //服务详情
        serviceInfo: {},
        realFromUrl: null,
        fromLoaded: false,
        //指南ID
        guideId: null,
        //指南详情
        serviceGuide: {},
        navList: [],

        orderData: {},

        currentShowIndex: 0,
        floatBoxPOS: {x: 0, y: 0},
        floatBoxIsShow: false,
        calendarObj: null,
        floatBoxPayload: {
          time: "",
          status: "",
          freeCount: "",
          holdCount: "",
        },

        /***
         * 【服务评价】
         ***/
        ratingList: [],
        ratingPageNumber: 1,
        ratingPageSize: 5,
        ratingPageCount: null,
        ratingTotalCount: null,
        ratingContent: "",
        ratingValue: 0,


        //当前服务在列表中的缓存数据
        currentServiceListStoreData: null,
        //当前正在预约的数据
        currentOrderHanleData: null,
        personageHistoryData: []
      }
    },
    props: {
      isShow: {
        type: Boolean,
        default: true,
      },
      detailData: {
        type: Object
      }
    },
    mounted() {
      this.calendarObj = this.$refs.orderCalendar;
      let extraPage = this.$refs.extraPage;
      console.log("@#@@@@@@@>>>", extraPage)
      Bus.$emit('toTop')
      this.currentServiceListStoreData = this.detailData
      //初始化navlist
      this.navList = [
        {
          //所有的都有
          title: "服务指南",
          id: 0,
          isShow: 1
        },
        {
          //应用系统
          title: "打开应用",
          id: 1,
          isShow: 0
        },
        {
          //线下流程有
          title: "在线预约",
          id: 2,
          isShow: 0
        },
        {
          //所有的都有
          title: "在线办理",
          id: 3,
          isShow: 1
        },
        {
          //所有的都有
          title: "服务评价",
          id: 4,
          isShow: 1
        },
        {
          //线上流程有
          title: "我的事项",
          id: 5,
          isShow: 0
        },
        {
          //所有的都没有
          title: "我的预约",
          id: 6,
          isShow: 0
        },

      ]
      this.currentShowIndex = 0
      this.guideId = this.detailData.guideId
      this.serviceId = this.detailData.appid;
      if (this.detailData.targetTab) {
        this.currentShowIndex = this.detailData.targetTab;
      }
      store.commit("toggleSideMenuShow", true);

      this.initServiceInfo()
      this.getGuideContent()
      this.initRatingInfo()
    },
    destroyed() {
      this.fromLoaded = false;
      this.realFromUrl = "";
    },
    methods: {
      ...mapMutations(['updateModalZIndex']),
      opened() {
        this.updateModalZIndex(this.$el)
      },
      getURLParamValue(param, url) {
        let search = ''
        if (!url) {
          search = window.location.search
        } else {
          search = '?' + url.split('?')[1]
        }

        function GetQueryString(name) {
          var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
          var r = search.substr(1).match(reg);
          if (r != null) return unescape(r[2]);
          return null;
        }

        return GetQueryString(param)
        let strArr = str.split('=')
        return strArr[strArr.length - 1]
      },
      getQueryVariable(variable, currentUrl) {
        if (currentUrl) {
          var query = currentUrl
        } else {
          var query = window.location.search.substring(1);
        }
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
          var pair = vars[i].split("=");
          if (pair[0] == variable) {
            return pair[1];
          }
        }
        return (false);
      },
      //请求服务基础信息
      async initServiceInfo() {
        let serviceData = await axios.post(apiConfig.REQUEST_URL + "/shall/f_getService?sysId=" + this.serviceId);
        console.log(serviceData);
        if (!serviceData.data.status) {
          console.log("%请求服务详情错误：initServiceInfo", "font-size:50px;color:#f60");
          return
        }
        serviceData = serviceData.data.data[0];
        this.serviceInfo = serviceData;
        this.plan_url = `${apiConfig.PLAN_URL}/jcforms/wfdesigner/operation/graph?processinstId=0&formId=${this.getURLParamValue('formId', this.serviceInfo.pc_url)}`
        this.getPersonageHistory(this.serviceInfo.name)
        switch (serviceData.type) {
          case 0:
            this.navList[3].title = '在线使用'
            break;
          case 1:
            if (serviceData.onlineSort === "online") {
              this.navList[5].isShow = 1;
            } else if (serviceData.onlineSort === "offline") {
              this.navList[3].isShow = 0;
            } else {
              this.navList[2].isShow = 1;
              this.navList[3].isShow = 0;
            }
            break;
          case 2:
            this.navList[1].isShow = 1;
            this.navList[3].isShow = 0;
            break;
          case 3:
            break;
          case 4:
            this.navList[3].title = '在线使用'
            break;
          default:
            console.log('initServiceInfo serviceData.type数据异常')
        }

        console.log(`${serviceData.name}权限状态：${serviceData.inPower} - type:${serviceData.type} - onlineSort:${serviceData.onlineSort}`)
        if (!serviceData.inPower) {
          for (let key in this.navList) {
            if (!(this.navList[key].id === 0 || this.navList[key].id === 4)) {
              this.navList[key].isShow = 0
            }
          }
        }
      },
      //请求指南
      async getGuideContent() {
        let guideData = await axios.post(apiConfig.REQUEST_URL + "/shall/front_getGuideInfo?" + this.$qs.stringify({
          id: this.guideId
        })).catch((err) => {
          console.log("请求指南出错：", err);
        });
        if (!guideData.data.status) {
          console.log("%请求指南错误：getGuideContent", "font-size:50px;color:#f60");
          return;
        }
        guideData = guideData.data.data[0];
        this.serviceGuide = guideData
      },
      //请求评价
      async initRatingInfo() {

        let ratingInfo = await axios.post(apiConfig.REQUEST_URL + "/shall/front_getEvaluateServiceList?" + this.$qs.stringify({
          sysId: this.serviceId,
          pageSize: this.ratingPageSize,
          pageNumber: this.ratingPageNumber,
          property: 'content',
          keyword: null
        }))
        if (ratingInfo.data.status) {
          ratingInfo = ratingInfo.data.data[0];
        }
        this.ratingList = ratingInfo.list;
        this.ratingPageNumber = ratingInfo.pageNumber;
        this.ratingPageSize = ratingInfo.pageSize;
        this.ratingPageCount = ratingInfo.pageCount;
        this.ratingTotalCount = ratingInfo.totalCount;

      },
      // 获取个人应用使用记录
      async getPersonageHistory(e) {
        let history = await axios.post(apiConfig.REQUEST_URL + "/shall/front_getUserMatters?" + this.$qs.stringify({
          pageNumber: 10,
          pageSize: 1,
          processInstName: '新建表单-1592891168483'
        }))
        if (history.data.status) {
          let historyList = history.data.data[0].list
          historyList.forEach(item => {
            switch (item.currentState) {
              case 1:
                item.currentText = '未启动'
                break;
              case 2:
                item.currentText = '进行中'
                break;
              case 3:
                item.currentText = '挂起'
                break;
              case 7:
                item.currentText = '已完成'
                break;
              case 8:
                item.currentText = '终止'
                break;
              default:
                console.log("currentState参数异常");
            }
          })
          this.personageHistoryData = historyList
        }
      },
      onMore() {
        this.ratingPageSize++
        this.initRatingInfo()
      },
      //提交评价
      async ratingSubmit() {
        let score = this.ratingValue;
        if (!this.ratingContent || this.ratingContent === "<p><br></p>") {
          this.$notify({
            group: "global",
            title: "温馨提示",
            text: "评价内容不能为空~",
          });
          return;
        }

        let resp = await axios.post(apiConfig.REQUEST_URL + "/shall/front_evaluateService?sysId=" + this.serviceId + '&content=' + this.ratingContent + '&score=' + score);
        if (resp.data.status) {
          this.$notify({
            group: "global",
            title: "温馨提示",
            text: "评价提交成功~",
          });
          this.ratingContent = "";
          this.ratingValue = 0;
          this.initRatingInfo();
        }
      },

      changeShowIndex(id) {
        this.currentShowIndex = id;
      },

      //切换收藏状态
      async toggleCollectStatus() {
        if (!this.$store.getters.getUserLoginStatus) {
          console.log("需要登录,当前没有登录")
          this.$notify({
            group: "global",
            title: "温馨提示",
            text: "登录后才能进行下一步操作！"
          });
          location.replace(apiConfig.REQUEST_URL + "/shall/users?info=" + this.$route.path);
        } else {
          this.serviceInfo.collection = !this.serviceInfo.collection;
          let resp = await axios.post(apiConfig.REQUEST_URL + "/shall/front_collectionService?sysId=" + this.serviceId + '&type=' + (this.serviceInfo.collection ? 1 : 0))
        }
      },
      //=========【在线预约】=========
      monthOffset(way) {
        this.$refs.orderCalendar.monthOffset(way);
      },
      getStatusDesc(n) {
        let descText = "";
        switch (parseInt(n)) {
          case 0:
            descText = "不可预约";
            break;
          case 1:
            descText = "预约已满";
            break;
          case 2:
            descText = "可预约";
            break;
          case 3:
            descText = "预约过半";
            break;
          default:
            console.log("getStatusDesc参数异常");
        }
        return descText;
      },
      mouseenter(d) {
        this.floatBoxPayload.time = d.date.cusArr.join("-") + " " + d.step.desc;
        this.floatBoxPayload.freeCount = d.step.freeCount;
        this.floatBoxPayload.holdCount = d.step.holdCount;
        this.floatBoxPayload.status = this.getStatusDesc(d.step.status);
        this.floatBoxIsShow = true;

      },
      mousemove(d) {
        let x = d.event.pageX;
        let y = d.event.pageY;
        this.floatBoxPOS.x = x;
        this.floatBoxPOS.y = y;

      },
      mouseleave(d) {
        this.floatBoxIsShow = false;
      },
      toToday() {
        this.$refs.orderCalendar.toToday();
      },

      //日历切换
      calendarChange() {
        this.setOrderCalendarData()
      },
      //设置日期时段数据
      setDateStepData(origin, targetData) {
        origin.forEach((item, index) => {
          item.status = targetData[index].status;
          item.freeCount = targetData[index].freeCount;
          item.holdCount = targetData[index].holdCount;
        });
        return origin;
      },
      setOrderCalendarData() {
        this.$refs.orderCalendar.calendarData.forEach((row, index) => {
          row.forEach((col, colIdx) => {
            let targetData = this.orderData[col.cusArr.join("-")];
            if (targetData) {
              col.stepArr = this.setDateStepData(col.stepArr, targetData);
            }
          })
        });
      },
      /***
       * 订购流程
       * d.date 日期
       * d.step 时段
       * d.event 事件对象
       * @param d
       */
      async orderAction(d) {
        console.log(d)
        let status = d.step.status;
        if (!status || status === 1) {
          this.$notify({
            group: "global",
            title: "温馨提示",
            text: "当前时间不可预约",
          });
          return;
        }
        console.log(`执行预约操作：日期${d.date.cusArr.join("-")}，时段${d.step.desc}`);

        let anonAction = 1;
        if (d.step.status === 4) {
          anonAction = 0;
        }

        if (anonAction === 1) {
          this.currentOrderHanleData = {sysId: this.serviceId, day: d.date.cusArr.join('-'), type: (d.step.id - 1)}
          return
        }

        //取消预约
        let orderResult = await axios.post(apiConfig.REQUEST_URL + "/shall/front_order?sysId=" + this.serviceId + '&day=' + d.date.cusArr.join("-") + '&type=' + (d.step.id - 1) + '&anon=' + anonAction);

        if (orderResult.data.status) {
          this.$refs.orderCalendar.toToday();
        }
        this.$notify({
          group: "global",
          title: "温馨提示",
          text: orderResult.data.msg,
        });

      },
      //关闭
      close() {
        this.navList[2].isShow = 0;
        this.navList[3].isShow = 0;

        if (this.$route.path.indexOf("/home") !== -1) {
          store.commit("toggleSideMenuShow", false);
        }
        this.currentShowIndex = 0;
        // this.$modal.hide("serviceHandle");
        this.$emit('closeServiceDetail')
      },
      //展示大图
      openNewTab(item) {
        window.open(item.storeName)
      },
      //去办理
      toHandle() {
        this.currentShowIndex = 3;
      },
      //打开地图
      openMap(x, y, text) {
        this.$modal.show("bdMap", {posX: x, posY: y, text});
      },
      //######评价相关的############
      ratingPageChange(pageIndex) {
        this.ratingPageNumber = pageIndex;
        this.initRatingInfo();
      },
      ratingPageSizeChange(newPageSize) {
        this.ratingPageNumber = 1;
        this.ratingPageSize = newPageSize;
        this.initRatingInfo();
      },
      //请求数据
      async borderDateOffset(data) {
        let orderInfo = await axios.post(apiConfig.REQUEST_URL + "/shall/front_getOrderInfo?sysId=" + this.serviceId + '&starttime=' + data.headDate + '&daynum=' + data.dateCount);
        if (!orderInfo.data.data.length) {
          return;
        }
        orderInfo = orderInfo.data.data[0];

        this.orderData = orderInfo;
        this.setOrderCalendarData()


      },
      closeOrderAction() {
        this.currentOrderHanleData = null
      },
      orderFinish() {
        this.closeOrderAction()
        this.$refs.orderCalendar.toToday();
      },
      handleServiceAction() {
        if (!this.getUserLoginStatus) {
          let targetURL = apiConfig.REQUEST_URL + "/shall/cgi-bin/login?url=" + window.location.origin + window.location.pathname + '$/personal'
          location.replace(targetURL)
          return
        }

        if (this.serviceInfo.appOpenType !== 'frame') {
          window.open(this.serviceInfo.pc_url)
          return
        }
        this.detailStatus = false
      }
    },
    watch: {
      currentShowIndex(newVal, oldVal) {
        if (newVal !== 0) {
          if (!this.$store.getters.getUserLoginStatus) {
            console.log("需要登录,当前没有登录")
            this.currentShowIndex = 0;
            this.$notify({
              group: "global",
              title: "温馨提示",
              text: "登录后才能进行下一步操作！"
            });

            //生成跳转数据
            let userActionData = {
              type: "serviceHandle",
              serviceId: this.serviceId,
              guideId: this.guideId,
              targetTab: newVal
            };
            let userActionDataStr = JSON.stringify(userActionData);
            userActionDataStr = userActionDataStr.replace(/{/g, '(')
            userActionDataStr = userActionDataStr.replace(/}/g, ')')
            location.replace(apiConfig.REQUEST_URL + "/shall/users?info=" + this.$route.path + `?loginData=${userActionDataStr}`);
          }
        }
        if (this.currentShowIndex === 1) {
          window.open(this.serviceInfo.pc_url)
        }
        //在线办理
        if (newVal === 3) {
          if (!this.getUserLoginStatus) {
            let targetURL = apiConfig.REQUEST_URL + "/shall/cgi-bin/login"
            console.log("targetURL", targetURL)
            location.replace(targetURL);
            return
          }
          if (this.serviceInfo.appOpenType !== 'frame') {
            this.currentShowIndex = 0
            window.open(this.serviceInfo.pc_url)
            return
          }
          if (this.fromLoaded) {
            return;
          }
          this.realFromUrl = this.serviceInfo.pc_url;
          this.fromLoaded = true;
        }
      }
    },
    filters: {
      //获取默认评分
      defaultScore(val) {
        if (!parseInt(val)) {
          return 3.5;
        }
        return val;
      },

    },
    computed: {
      ...mapGetters(['getUserLoginStatus']),
      floatBoxStyle() {
        let offsetDistance = 10;
        let display = this.floatBoxIsShow ? "block" : "none";
        return `left:${this.floatBoxPOS.x + offsetDistance}px;top:${this.floatBoxPOS.y + offsetDistance}px;display:${display}`;
      },
      getServiceStateData() {
        return {
          finishNum: this.currentServiceListStoreData.finishNum,
          myApplyNum: this.currentServiceListStoreData.myApplyNum,
          runingNum: this.currentServiceListStoreData.runingNum
        }
      },

      getHandleType() {
        switch (this.serviceInfo.onlineSort) {
          case 'online':
            return 1
          case 'offlineorder':
            return 2
          case 'sso':
            return 3
          default:
            return false
        }
      },
      getHandleBtnText() {
        switch (this.getHandleType) {
          case 1:
            return '在线办理'
          case 2:
            return '在线预约'
          case 3:
            return '在线使用'
          default:
            return false
        }
      }
    },
    components: {orderCalendar, rating, serviceRating, ratingSet, stateBall, bdMap, orderAction, serviceTodo, collect}
  }
</script>

.header
<style lang="stylus" scoped>
  @import "../../common/stylus/config.styl"

  @media screen and (max-width: 1440px)
    .header-right
      margin-right 5rem

  .serviceDetail
    width 100%
    height 100%
    background #f4f4f4

    .title
      width 100%
      height 50px
      box-sizing border-box
      line-height 50px

      .title-left
        float left

        span
          font-weight bold
          color #222222
          font-size 16px

    .header
      width 100%
      height 90px
      background #ffffff
      position relative

      .close
        position absolute
        cursor pointer
        top 20px
        right 42px

      .headerBox
        width 1400px
        height 100%
        margin 0 auto

        .header-left
          position relative
          top 50%
          transform translateY(-50%)
          float left

          .Img
            width 50px
            height 50px
            border-radius 50%
            overflow hidden
            background yellow
            float left

            img
              width 100%
              height 100%

          .Text
            height 100%
            display flex
            flex-direction column
            justify-content center
            margin-left 12px
            float left
            margin-top 5px

            .rating
              margin-top 10px

        .header-right
          height 100%
          float right

          .btn
            width 160px
            height 46px
            background #548edf
            color #ffffff
            border-radius 5px
            font-size 16px
            cursor pointer
            float left
            text-align center
            line-height 46px
            margin-top 22px

          .biao
            margin-top 30px

            div
              width 78px
              height 30px
              text-align center
              line-height 30px
              background rgba(242, 244, 245, 1)
              border-radius 5px
              font-size 12px
              color #666666
              margin-left 5px
              float left

    .container
      width 1400px
      margin 0 auto
      margin-top 18px
      padding-bottom 25px
      overflow hidden

      .container-left
        width 1030px
        padding 0 29px
        padding-bottom 15px
        box-sizing border-box
        background #ffffff
        border-radius 8px
        float left
        min-height: 574px;

        .title-right
          float right

          div
            margin-left 15px
            cursor pointer
            float left

            i
              color #B7B9BB
              font-size 13px

            span
              color #666666
              font-size 12px

        .qr-container
          position relative

          &:hover
            .qrcode
              display block

          .qrcode
            display none
            position absolute
            left -56px
            top 85%
            z-index 8
            background-color #ffffff
            border 1px solid #cccccc
            box-shadow 2px 2px 3px #cccccc
            width 150px
            height 150px
            padding 10px

            img
              width 100%
              height 100%

        .guide
          width 100%

          .guide-item
            width 100%

            .guide-item-title
              border-left 3px solid themeColor
              margin-bottom 15px
              margin-top 15px
              padding-left 8px
              font-size 14px

            .imgContainer
              img
                max-width 100%

      .container-right
        width 350px
        float right

        .unit
          width 350px
          height 572px
          background #ffffff
          border-radius 8px
          padding 0 20px
          box-sizing border-box

          ul
            width 100%
            height 510px

            li
              width 100%
              height 72px

              p
                padding 8px 0
                box-sizing border-box
                color #666666
                font-size 14px

        .matter
          width 350px
          height 517px
          background #ffffff
          border-radius 8px
          margin-top 20px
          padding 0 20px
          box-sizing border-box

          .title-right
            height 100%
            float right

            i
              font-size 13px
              color #CB4258
              margin-left 5px
              cursor pointer

            span
              font-size 12px
              color #CB4258
              cursor pointer

          .num
            width 100%
            font-size 12px
            color #666666
            margin-bottom 14px

            span
              margin-right 10px

          ul
            width 100%

            .matter-item
              width 100%
              border-bottom 1px solid #EEEEEE
              padding 14px 0

              .content
                width 100%
                margin-bottom 14px
                float left

                .content-left
                  width 60%
                  font-size 14px
                  color #666666
                  float left
                  overflow hidden
                  white-space nowrap
                  text-overflow ellipsis
                  -o-text-overflow ellipsis

                .content-right
                  font-size 14px
                  color #999999
                  float right

              .time
                font-size 14px
                color #999999

    .handle
      width 1100px
      margin 0 auto
      margin-top 16px
      padding-bottom 100px

      .iframeBox
        width 100%
        background #ffffff
        border-radius 8px
        padding 0 60px
        padding-bottom 33px
        box-sizing border-box
        overflow hidden

        .title-right
          height 100%
          float right

          div
            float left
            margin-left: 15px;

            i
              font-size 13px
              color #B7B9BB
              margin-left 18px
              cursor pointer

            span
              font-size 12px
              color #666666
              cursor pointer

          .qr-container
            position relative

            &:hover
              .qrcode
                display block

            .qrcode
              display none
              position absolute
              left -56px
              top 85%
              z-index 8
              background-color #ffffff
              border 1px solid #cccccc
              box-shadow 2px 2px 3px #cccccc
              width 150px
              height 150px
              padding 10px

              img
                width 100%
                height 100%

        .iframe
          width 100%
          height 800px

        .btnBox
          float left
          position relative
          left 50%
          transform translateX(-50%)
          margin-top 40px

          div
            width 90px
            height 34px
            border-radius 3px
            border 1px solid rgba(238, 238, 238, 1)
            font-size 14px
            color #666666
            margin 0 2.5px
            cursor pointer
            float left
            text-align center
            line-height 34px

            &:nth-of-type(1)
              background #548EDF
              color #ffffff

        .orderOnline

          .orderinfo
            margin-bottom 20px

            &::after
              content ""
              display block
              width 100%
              clear both

            .avatar
              width 60px
              height 60px
              margin-right 10px
              float left

            & > h3
              font-size 20px
              line-height 30px
              color #333333

            & > p
              float left
              line-height 35px
              margin-right 20px
              font-size 14px
              color #999999

            & > ul
              float right
              margin-top -20px

              li
                display inline-block
                width 58px
                height 25px
                background-color #3E50B4
                font-size 12px
                line-height 25px
                text-align center
                color #ffffff
                border-radius 12px
                cursor pointer
                user-select none

                &:nth-of-type(2)
                  background-color #16A61E

          .floatBox
            width 272px
            height 110px
            border 1px solid #c8ba92
            z-index 999
            position fixed
            overflow hidden

            h4
              border-bottom 1px solid #c8ba92
              background-color #f3f0e7
              font-size 14px
              padding-left 1em
              color #333333
              height 33px
              line-height 33px
              font-weight bold

            div
              background-color #ffffff
              font-size 14px
              color #666666
              height 78px
              padding 0.5em 1em
              line-height 20px

          .desc
            float right

            p
              font-size 12px
              padding-left 20px
              line-height 26px
              color #666

              & > span
                width 20px
                height 20px
                display inline-block
                vertical-align middle
                margin-bottom 3px
                margin-right 10px

              .grey
                background-color #e6e6e6

              .blue
                background-color #299bdf

              .yellow
                background-color #ffd700

              .red
                background-color #f96262

              .green
                color #ffffff
                text-align center
                line-height 22px
                background-color #16a61e

          //在线预约

          .orderCalendar
            overflow hidden

            & >>> .calendar
              .row
                height 60px

                .col
                  line-height 30px
                  border 1px solid #e1e1e8
                  /*border-bottom none*/
                  background-color #ffffff
                  position relative

                  &.today
                    background-color #005ab3
                    color #ffffff
                    font-weight bold

                  &::after
                    display block
                    content ""
                    right 0
                    top 0
                    bottom 0
                    position absolute
                    border-right 3px solid #005ab3

                  &.weekItem ul li::after
                    display none

                  ul
                    width 100%
                    height 28px

                    li
                      height 100%
                      width 33%
                      float left
                      position relative
                      background-color #ffffff
                      border 1px solid #e6e6e6
                      border-bottom none

                      &.no::after
                        background-color #e6e6e6
                        cursor not-allowed

                      &.full::after
                        background-color #f96262
                        cursor not-allowed

                      &.can::after
                        background-color #299bdf
                        cursor pointer

                      &.half::after
                        background-color #ffd700
                        cursor pointer

                      &.ordered::after
                        background-color #16a61e
                        cursor pointer

                      &::after
                        content ""
                        left 0
                        right 0
                        top 0
                        bottom 0
                        margin auto
                        display inline-block
                        width 20px
                        height 20px
                        position absolute

                      .iconfont
                        position relative
                        color #ffffff
                        display block
                        font-size 16px
                        z-index 9

  .processBox
    width 100%
    border-radius 8px
    background #ffffff
    margin-top 10px
    margin-bottom 10px
    padding 21px 61px
    box-sizing border-box

    h2
      border-left 3px solid themeColor
      padding-left 8px

    .process
      width 100%
      height 490px
      margin-top 20px

      iframe
        width 100%
        height 100%

    .step
      width 100%
      height 80px

      .con
        margin 0 auto
        position relative
        left 50%
        transform translateX(-50%)
        float left
        margin-top 19px

        .line
          width 100%
          height 3px
          background #F2F4F5
          position absolute
          left 0
          top 50%
          transform translateY(-50%)

        .step-item
          width 30px
          height 30px
          float left
          border-radius 50%
          border 1px solid #f2f4f5
          font-size 14px
          color #888888
          margin 0 50px
          z-index 3
          background #ffffff
          text-align center
          line-height 27px
          position relative

          &:nth-of-type(2)
            margin-left 0 !important

          &:last-of-type
            margin-right 0 !important

          .text
            min-width 100px
            max-width 140px
            color #888888
            font-size 12px
            position absolute
            top 135%
            left 50%
            transform translateX(-50%)
            text-align center

  .evaluateBox
    width 100%
    border-top-left-radius 8px
    border-top-right-radius 8px
    background #ffffff
    padding 21px 61px
    box-sizing border-box

    h2
      border-left 3px solid themeColor
      padding-left 8px

      & >>> .el-rate
        display inline
        margin-left 10px
        position relative
        top -2px

    .input-container
      width 100%
      height 215px
      margin 20px 0
      overflow hidden

      /deep/ .wangEditor-container
        height 100% !important

        .wangEditor-txt
          height 100% !important

    .btnBox
      width 100%
      height 34px
      margin-bottom 32px

      .btn
        width 90px
        height 34px
        background #548EDF
        color #ffffff
        border-radius 5px
        font-size 14px
        color #ffffff
        cursor pointer
        text-align center
        line-height 34px
        float right

  .evaluateList
    width 100%
    border-top 1px solid #EEEEEE
    background #ffffff
    padding 0 60px
    margin-bottom 50px
    box-sizing border-box

    .number
      width 100%
      font-size 14px
      color #333333
      margin 19px 0 27px 0
      font-weight bold

    .more {
      width 100%
      height 30px
      line-height 30px
      text-align center
      font-size 14px
      padding-bottom 50px
    }

    .more p {
      cursor pointer
    }

    .list
      width 100%
      margin-bottom 23px

      .list-user
        width 100%
        overflow hidden

        .Img
          width 23px
          height 23px
          border-radius 50%
          overflow hidden
          float left

          img
            width 100%
            height 100%

        .name
          font-size 14px
          color #222222
          margin-left 8px
          float left
          margin-top 3px

        .time
          float right
          font-size 14px
          color #666666

      .list-con
        width 100%
        padding-left 31px
        margin-top 10px
        color #666666
        font-size 14px
        padding-bottom 19px
        border-bottom 1px solid #EEEEEE


</style>



// WEBPACK FOOTER //
// src/components/service/serviceDetail.vue